module.exports = __webpack_public_path__ + "img/free-voucher.9f89b98a.png";